export default function contactsMap() {

   

    console.log('Зарегистрировали функцию')

    function init() {
      
        const mapElement = document.querySelector('.js-contacts-map');
       
        if (!mapElement) return;
       

        const coords = [parseFloat(mapElement.getAttribute('data-lat')), parseFloat(mapElement.getAttribute('data-lng'))]

        console.log('Coords', coords);

        const zoomIn = document.querySelector('.js-map-zoom-in');
        const zoomOut = document.querySelector('.js-map-zoom-out');
      

        let map = new ymaps.Map(mapElement, {
			center: coords,
			zoom: 17,
			controls: []
        })
        
        const myPlacemark = new ymaps.Placemark(coords, {}, {
            
            iconLayout: 'default#image',
            iconImageHref: mapElement.getAttribute('data-pin'),
            iconImageSize: window.matchMedia('(max-width: 568px)').matches ? [40, 48] : [50, 60],
            iconImageOffset: window.matchMedia('(max-width: 568px)').matches ? [-20, -48] : [-25, -60]
        });

        map.geoObjects.add(myPlacemark);


        zoomIn.addEventListener('click', event => {
            event.preventDefault();

            const currentZoom = map.getZoom();

            map.setZoom(currentZoom + 1, {
                duration: 200
            });
        })
        zoomOut.addEventListener('click', event => {
            event.preventDefault();

            const currentZoom = map.getZoom();

            map.setZoom(currentZoom - 1, {
                duration: 200
            });
        })
    }


    ymaps.ready(init);
}